import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { dataSegmentos, SectionMenu } from '../../models';
import { environment } from '../../../../environments/environment';
import { NzNotificationService } from 'ng-zorro-antd/notification';

declare var $: any;

@Component({
  standalone: false,
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements AfterViewInit, OnInit {
  public menuSidebar: SectionMenu[] = [];
  public dataSegmentos: dataSegmentos;

  constructor(
    private cdr: ChangeDetectorRef,
    private notificationService: NzNotificationService
  ) {
    const dataSegmentosStorage: any = sessionStorage.getItem("dataSegmentos");
    this.dataSegmentos = JSON.parse(dataSegmentosStorage);

    if (environment.production) {
      this.menuSidebar = [
        {
          title_section: "Administración",
          visible: false,
          menu: [
            {
              icono: "bx bx-check-shield",
              visible: false,
              submenu: [
                {
                  href: "administracion/ver_roles",
                  id: "1",
                  visible: false,
                  label: "Visor"
                },
                {
                  href: "administracion/crear_rol",
                  id: "2",
                  visible: false,
                  label: "Añadir nuevo"
                },
                {
                  href: "administracion/ver_vigencias",
                  id: "3",
                  visible: false,
                  label: "Vigencias"
                }
              ],
              id: "1",
              label: "Roles"
            },
            {
              icono: "bx bx-user",
              visible: false,
              submenu: [
                {
                  href: "administracion/ver_usuarios",
                  id: "1",
                  label: "Visor",
                  visible: false
                },
                {
                  href: "administracion/crear_usuario",
                  id: "2",
                  label: "Añadir nuevo",
                  visible: false
                }
              ],
              id: "2",
              label: "Usuarios"
            },
            {
              icono: "bx bx-buildings",
              visible: false,
              submenu: [
                {
                  href: "administracion/crear_emisor",
                  id: "2",
                  label: "Añadir nuevo",
                  visible: false
                }
              ],
              id: "3",
              label: "Emisores"
            }
          ]
        },
        {
          title_section: "Refacturacion",
          visible: false,
          menu: [
            {
              icono: "bx bx-receipt",
              href: "refacturacion/refacturar_ticket",
              id: "1",
              visible: false,
              label: "Ticket"
            }
          ]
        },
        {
          title_section: "Reporteria",
          visible: false,
          menu: [
            {
              icono: "bx bx-file",
              href: "reporteria/ver_facturas_emitidas",
              id: "1",
              visible: false,
              label: "Facturas"
            },
            {
              icono: "bx bx-receipt",
              href: "reporteria/ver_tickets",
              id: "2",
              visible: false,
              label: "Tickets"
            },
            {
              icono: "bx bxs-report",
              href: "reporteria/descarga_reporte",
              id: "3",
              visible: false,
              label: "Reportes"
            },
            {
              icono: "bx bxs-file-archive",
              href: "reporteria/descarga_masiva",
              id: "4",
              visible: false,
              label: "Descargas masivas"
            }
          ]
        },
        {
          title_section: "ADD-ON",
          visible: false,
          menu: [
            {
              icono: "bx bx-wallet",
              externalAction: "nuevo_portal",
              id: "1",
              visible: false,
              label: "Cuentas por cobrar"
            }
          ]
        }
      ];
    } else {
      this.menuSidebar = [
        {
          title_section: "Administración",
          visible: false,
          menu: [
            {
              icono: "bx bx-check-shield",
              visible: false,
              submenu: [
                {
                  href: "administracion/ver_roles",
                  id: "1",
                  visible: false,
                  label: "Visor"
                },
                {
                  href: "administracion/crear_rol",
                  id: "2",
                  visible: false,
                  label: "Añadir nuevo"
                },
                {
                  href: "administracion/ver_vigencias",
                  id: "3",
                  visible: false,
                  label: "Vigencias"
                }
              ],
              id: "1",
              label: "Roles"
            },
            {
              icono: "bx bx-user",
              visible: false,
              submenu: [
                {
                  href: "administracion/ver_usuarios",
                  id: "1",
                  label: "Visor",
                  visible: false
                },
                {
                  href: "administracion/crear_usuario",
                  id: "2",
                  label: "Añadir nuevo",
                  visible: false
                }
              ],
              id: "2",
              label: "Usuarios"
            },
            {
              icono: "bx bx-buildings",
              visible: false,
              submenu: [
                {
                  href: "administracion/crear_emisor",
                  id: "2",
                  label: "Añadir nuevo",
                  visible: false
                }
              ],
              id: "3",
              label: "Emisores"
            }
          ]
        },
        {
          title_section: "ADD-ON",
          visible: false,
          menu: [
            {
              icono: "bx bx-wallet",
              externalAction: "nuevo_portal",
              id: "1",
              visible: false,
              label: "Cuentas por cobrar"
            }
          ]
        },
        {
          title_section: "Refacturacion",
          visible: false,
          menu: [
            {
              icono: "bx bx-receipt",
              href: "refacturacion/ver_refacturaciones",
              id: "1",
              visible: false,
              label: "Visor refacturación"
            },
            {
              icono: "bx bx-receipt",
              href: "refacturacion/refacturar_ticket",
              id: "1",
              visible: false,
              label: "Ticket"
            }
          ]
        },
        {
          title_section: "Reporteria",
          visible: false,
          menu: [
            {
              icono: "bx bx-file",
              href: "reporteria/ver_facturas_emitidas",
              id: "1",
              visible: false,
              label: "Facturas"
            },
            {
              icono: "bx bx-receipt",
              href: "reporteria/ver_tickets",
              id: "2",
              visible: false,
              label: "Tickets"
            },
            {
              icono: "bx bxs-report",
              href: "reporteria/descarga_reporte",
              id: "3",
              visible: false,
              label: "Reportes"
            },
            {
              icono: "bx bxs-file-archive",
              href: "reporteria/descarga_masiva",
              id: "4",
              visible: false,
              label: "Descargas masivas"
            }
          ]
        }
      ];
    }
  }

  ngOnInit(): void {
    this.menuSidebar.forEach(sectionmenu => {
      sectionmenu.menu.forEach(option => {
        if (option.href) {
          const splitOnlyOption = option.href.split("/");
          const onlyOption = splitOnlyOption.at(-1);
          if (this.dataSegmentos?.funcionalidades?.includes(onlyOption!)) {
            option.visible = true;
          }
        } else if (option.externalAction) {
          if (option.externalAction === 'nuevo_portal') {
            option.visible = !!this.dataSegmentos?.funcionalidades?.includes('ver_cxc');
          }

        } else if (option.submenu) {
          option.submenu.forEach(suboption => {
            if (suboption.href) {
              const splitOnlySuboption = suboption.href.split("/");
              const onlySuboption = splitOnlySuboption.at(-1);

              if (this.dataSegmentos?.funcionalidades?.includes(onlySuboption!)) {
                suboption.visible = true;
              }
            }
          });
        }
      });
    });

    this.menuSidebar.forEach(sectionmenu => {
      sectionmenu.menu.forEach(option => {
        if (option.submenu) {
          option.visible = option.submenu.some(suboption => suboption.visible === true);
        }
      });
    });

    this.menuSidebar.forEach(sectionmenu => {
      sectionmenu.visible = sectionmenu.menu.some(option => option.visible === true);
    });
  }

  public onExternalActionClick(action?: string): void {
    if (!action) return;
    switch (action) {
      case 'nuevo_portal':
        this.openAddon(environment.url_addon_portal);
        break;
      default:
        break;
    }
  }

  public openAddon(urlBase: string): void {
    if (!urlBase || urlBase.trim() === '') {
      console.warn('La URL del portal ADD-ON aún no ha sido configurada.');
      this.notificationService?.warning('ADD-ON', 'La URL del portal destino aún no ha sido configurada.');
      return;
    }

    const token = sessionStorage.getItem('token');
    if (!token) {
      console.warn('No se encontró un token de sesión activo.');
      this.notificationService?.error('Sesión inválida', 'No se encontró un token de sesión activo.');
      return;
    }

    const url = `${urlBase}/login/${encodeURIComponent(token)}`;
    window.open(url, '_blank', 'noopener,noreferrer');

    if (window.innerWidth <= 768) {
      $(".overlay-sidebar").remove();
      $(".page-wrapper").removeClass("toggled");
    }
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();

    $(".sidebar-dropdown > a").click(function () {
      $(".sidebar-submenu").slideUp(200);
      if ($(this).parent().hasClass("active")) {
        $(".sidebar-dropdown").removeClass("active");
        $(this).parent().removeClass("active");
      } else {
        $(".sidebar-dropdown").removeClass("active");
        $(this).next(".sidebar-submenu").slideDown(200);
        $(this).parent().addClass("active");
      }
    });
  }


}

